module.exports = __webpack_public_path__ + "img/edit.4721617.svg";